<template>
    <div class="audience" >
        <h2 v-if="title" class="title audience-title">
            {{title}}
        </h2>
        <p v-if="subtitle" class="text">
            {{subtitle}}
        </p>
        <div class="stats-container">
            <div class="stats">
                <div class="stat">
                    <h2 class="title">{{stat1Number}}</h2>
                    {{stat1Title}}
                </div>
                <div class="stat">
                    <h2 class="title">{{stat2Number}}</h2>
                    {{stat2Title}}
                </div>
                <div class="stat desktop">
                    <h2 class="title">{{stat3Number}}</h2>
                    {{stat3Title}}
                </div>
            </div>
        </div>
        <img v-if="imgURL" :src="imgURL">
    </div>
</template>

<script>
export default {
    name:"AudienceBlock",
    props:{
        title:{
            type: String,
            default: ''
        },
        subtitle:{
            type: String,
            default: ''
        },
        stat1Number:{
            type:String,
            default: ''
        },
        stat1Title:{
            type:String,
            default: ''
        },
        stat2Number:{
            type:String,
            default: ''
        },
        stat2Title:{
            type:String,
            default: ''
        },
        stat3Number:{
            type:String,
            default: ''
        },
        stat3Title:{
            type:String,
            default: ''
        },
        imgURL:{
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.audience{
    text-align: center;
    &>img{
        width: 100%;
    }
    .audience-title{
        margin: 1rem 70px;
    }
    .text{
        margin: 0 70px;
        margin-bottom: 2rem;
    }
}
.stats-container{
    background: rgb(2,0,36);
    background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(185,63,95,1) 0%, rgba(123,165,211,1) 100%);
    padding: 0 110px;
    height: 250px;
    display: flex;
}
.stats{
    display: flex;
    color: #fff;
    width: 100%;
    max-width: 910px;
    margin: 0 auto;
    align-self: center;
    &>div{
        width: 33.33%;
    }
    .stat{
        display:flex;
        flex-direction: column;
        flex-wrap: wrap;
        margin: 3rem 0;
        h2{
            font-size: 51px;
            margin: 0;
            margin-bottom: 11px;
        }
    }
}

@media (max-width: $mobile) {
    .stats-container{
        padding: 0 2rem;
        height: unset;
    } 
    .audience{
        text-align: center;
        &>img{
            display:none;

        }
        .audience-title{
            margin: 3rem 2rem 2rem;
        }
        .text{
            margin: 0 2rem;
            margin-bottom: 2rem;
        }
    }
    .stats{
        .stat{
            width: 50%;
            margin: 77px 0;
            h2{
                font-size: 36px;
            }
        }
    }

}
</style>